import React, { FunctionComponent, useMemo } from 'react';
import { IGameRequest } from '@interfaces/IGameRequest';
import { Table, Button } from 'antd';
import css from './GameRequestModalPreview.module.less';
import useTranslate from '@hooks/useTranslate';
import componentContent from '../GamesPage.module.json';
import { ColumnsType } from 'antd/lib/table';
import GameCardCell from '@components/GameCard/GameCardCell';

interface GameRequestModalProps {
  games: IGameRequest[];
  deleteGame: (id: number) => void;
}
const GameRequestModalPreview: FunctionComponent<GameRequestModalProps> = ({
  games,
  deleteGame,
}) => {
  const content = useTranslate(componentContent);

  const columns: ColumnsType<IGameRequest> = useMemo(() => {
    const col: ColumnsType<IGameRequest> = [
      {
        key: 'id',
        dataIndex: 'id',
        title: content.id,
        width: 56,
      },
      {
        key: 'name',
        title: content.name,
        render: (_, game) => (
          <GameCardCell text={game.name} urlImg={game?.image?.url || ''} isEmpty={!game} />
        ),
      },
    ];
    if (games.length > 1) {
      col.push({
        key: 'action',
        render: (text, record) => (
          <Button htmlType='button' type='link' onClick={() => deleteGame(record.id)}>
            Delete
          </Button>
        ),
      });
    }
    return col;
  }, [content.id, content.name, deleteGame, games]);

  return (
    <>
      <Table
        rowKey='id'
        dataSource={games}
        columns={columns}
        pagination={false}
        className={css.preview__table}
      />
    </>
  );
};

export default GameRequestModalPreview;
